export default __webpack_public_path__ + "static/media/DefaultSchoolLogo.14282892.png";